import { getLeFEOrigin } from '@utils/util';

export const LbgStrategyLeFE = () => (
    <iframe className="admin-iframe" title="LBG 策略管理" src={`${getLeFEOrigin()}/#/app/admin/scheduling_strategy`} />
);
